import React from 'react';
import { PortalSelector } from 'insify-remote-component-loader';
import { useAccount } from '../../providers/authenticationProvider';

export const PortalSelectorLoader = () => {
  const account = useAccount();
  return <PortalSelector account={account} portal={{ name: 'Insify Document', displayName: 'Document' }} />;
};
